import { render, staticRenderFns } from "./SmsConfiguration.vue?vue&type=template&id=6439618e"
import script from "./SmsConfiguration.vue?vue&type=script&lang=js"
export * from "./SmsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports